export default __webpack_public_path__ + "static/media/commulino-white.9da05239.svg";